import { BaseService } from "./base.service";
import { BehaviorSubject, catchError, Observable, of } from "rxjs";
import { CollectionViewer, DataSource } from "@angular/cdk/collections";
import { MapperFunction } from "../types/types";
import { pageSizeDefault } from "../constants/constants";
import { SubSink } from "subsink";

export class BaseDataSource<T> implements DataSource<T> {

    private readonly subject = new BehaviorSubject<T[]>([]);
    readonly source$ = this.subject.asObservable();

    private readonly subs = new SubSink();

    public count: number = 0;

    public get baseFilter(): any {
        return this.filter;
    }

    constructor(
        protected service: BaseService<T>,
        protected mapper?: MapperFunction<T>,
        protected filter?: any,
        protected order?: string
    ) { }

    connect(_: CollectionViewer): Observable<T[]> {
        return this.source$;
    }

    disconnect(_: CollectionViewer): void {
        this.subject.complete();
        this.subs.unsubscribe();
    }
  
    load(filter?: any, order: string = '', desc: boolean = false, page: number = 0, size: number = pageSizeDefault): void {
        const criteria = {
            ...this.filter,
            ...filter
        }
        if (!order) {
            order = this.order ?? '';
        }
        this.subs.sink = this.service.get(criteria, order, desc, page, size)
            .pipe(catchError(() => of(null)))
            .subscribe(result => {
                if (result) {
                    const data = this.mapper ? this.mapper(result.items) : result.items; 
                    this.subject.next(data)
                    this.count = result.total;
                }
            });
    }  

}